// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton_skeleton__0rXj5","skeleton-loading":"skeleton_skeleton-loading__NgYyq"};